import { render } from "./ShopProfile.vue?vue&type=template&id=1270b6f2"
import script from "./ShopProfile.vue?vue&type=script&lang=js"
export * from "./ShopProfile.vue?vue&type=script&lang=js"

import "./ShopProfile.vue?vue&type=style&index=0&id=1270b6f2&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__